const RELATIVE_URL_BASE = "https://mem.ai";

/**
 * Appends the assigned Proactive price (whole dollars) to a Mem Agent learn-more URL.
 */
export const getLearnMoreHrefWithPrice = ({
  learnMoreHref,
  proactivePriceCents,
}: {
  learnMoreHref: string;
  proactivePriceCents?: number;
}): string => {
  if (proactivePriceCents === undefined || !Number.isFinite(proactivePriceCents)) {
    return learnMoreHref;
  }

  const price = Math.trunc(proactivePriceCents / 100);
  const url = new URL(learnMoreHref, RELATIVE_URL_BASE);
  url.searchParams.set("price", String(price));

  if (url.origin === RELATIVE_URL_BASE && !learnMoreHref.match(/^[a-z][a-z\d+\-.]*:/i)) {
    return `${url.pathname}${url.search}${url.hash}`;
  }

  return url.toString();
};
